import React from 'react'
import { compose } from 'redux'
import injectSheet from 'react-jss'
import { injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import cx from 'classnames'
import opacity from '../../../constants/opacity'

class BackgroundLayer extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
    }
  }

  render () {
    const { classes, color, blur, className, children, ...rest } = this.props
    const defaultColor = '#383838' + opacity[30]
    const defaultBlur = 10

    return (
      <div className={cx(classes.wrap, className)} {...rest}>
        {children}
        <div
          className={classes.background}
          style={{
            backgroundColor: color || defaultColor,
            filter: blur ? `blur(${blur}px)` : `blur(${defaultBlur}px)`,
          }}
        />
      </div>
    )
  }
}

const styles = {
  wrap: {
    position: 'relative',
  },
  background: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: -1,
  },
}

const mapStateToProps = (state) => {
  return {

  }
}

const mapDispatchToProps = {

}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  injectSheet(styles),
  injectIntl,
)(BackgroundLayer)



// WEBPACK FOOTER //
// ./src/components/scenes/DirectoryPage/BackgroundLayer.jsx